import { render, staticRenderFns } from "./TherapyFeedback.vue?vue&type=template&id=2603f033&scoped=true&"
import script from "./TherapyFeedback.vue?vue&type=script&lang=js&"
export * from "./TherapyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./TherapyFeedback.vue?vue&type=style&index=0&id=2603f033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603f033",
  null
  
)

export default component.exports